import React, { useState, useEffect } from "react";
import {
  Box,
  Image,
  Text,
  VStack,
  useToast,
  Center,
  Wrap,
  WrapItem,
  HStack,
} from "@chakra-ui/react";

import Spinner from "../../components/UI/Spinner";
import FGame1Img from "../../assets/Game1AbajoDerecha.png";
import SGame1Img from "../../assets/Game1ArribaIzquierda.png";
import FGame2Img from "../../assets/Game2AbajoIzq.png";
import SGame2Img from "../../assets/Game2ArribaDer.png";
import axios from "../../lib/axios";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
} from "@chakra-ui/react";

const Game = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [serverResponse, setServerResponse] = useState(null);
  const nivelId = localStorage.getItem("nivelId");

  const [games, setGames] = useState([]);
  const [tries, setTries] = useState([]);
  const startGameHour = new Date().toISOString();
  const [currentGameIndex, setCurrentGameIndex] = useState(0);
  // eslint-disable-next-line
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const toast = useToast();
  const navigate = useNavigate();
  const kid = useSelector((state) => state.kid.selectedKid);

  useEffect(() => {
    console.log(nivelId);
    fetch("https://teaapitest.azurewebsites.net/Deck")
      .then((res) => res.json())
      .then((data) => {
        setGames(data.data);
      })
      .catch((error) => console.error("Error fetching data: ", error));
      // eslint-disable-next-line
  }, []);

  const handleAnswer = (respuesta, index, game) => {
    respuesta.horaIntento = new Date().toISOString();
    setTries([...tries, respuesta]);
    setSelectedAnswer(index);
    const message = respuesta.esCorrecta ? "¡Correct!" : "Wrong";
    const status = respuesta.esCorrecta ? "success" : "error";

    toast({
      title: message,
      status: status,
      duration: 1000,
      isClosable: true,
    });

    if (respuesta.esCorrecta) {
      setTimeout(() => {
        setCurrentGameIndex((prevIndex) =>
          prevIndex + 1 < games.length ? prevIndex + 1 : prevIndex
        );
        setSelectedAnswer(null); // Reset the selected answer for the next game
      }, 2000);
      if (games.length - 1 === games.indexOf(game)) {
        let dataCompleteLevel = {
          nivelId: nivelId ? parseInt(nivelId) : 1,
          hijoId: kid ? kid.hijoId : 1,
          horaInicioNivel: startGameHour,
          horaFinNivel: new Date().toISOString(),
          intentos: tries,
        };
        axios
          .post(`/Levels/complete-level`, dataCompleteLevel)
          .then((response) => {
            if (response.data.success) {
              toast({
                title: "Level completed",
                status: "success",
                duration: 3000,
                isClosable: true,
              });
              setServerResponse(response.data.data);
              setModalIsOpen(true);
            } else {
              toast({
                title: "Error completing level",
                description: response.data.message,
                status: "error",
                duration: 3000,
                isClosable: true,
              });
            }
          })
          .catch((error) => {
            console.error("Error:", error);
          });
        console.log(dataCompleteLevel);
      }
    }
  };

  const renderGameType1 = (game) => {
    // Estilos para el título
    const titleStyle = {
      color: "#303030",
      textAlign: "center",
      fontFamily: "Poppins",
      fontSize: "40px",
      fontWeight: "600",
      lineHeight: "38px",
      letterSpacing: "-0.01px",
    };

    // Estilos para la imagen
    const imageStyle = {
      width: "539px",
      height: "346px",
      borderRadius: "50px",
      boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
      flexShrink: 0,
    };

    // Estilos para los botones
    const buttonStyle = {
      borderRadius: "20px",
      backgroundColor: "var(--TEA-Dark-Teal, #739691)",
      display: "grid",
      p: "21px 58px",
      justifyContent: "center",
      alignItems: "center",
      color: "white",
      fontSize: "18px",
      fontFamily: "Poppins",
      fontWeight: "500",
      _hover: {
        backgroundColor: "#5b7a74", // Considera definir un color más oscuro para el hover
      },
      cursor: "pointer", // Añade un cursor pointer para indicar que es un botón
    };

    return (
      <>
        <img
          src={FGame1Img}
          alt="Primera imagen"
          style={{
            position: "fixed",
            bottom: "0",
            right: "0",
            zIndex: "-1",
          }}
        />
        <img
          src={SGame1Img}
          alt="Segunda imagen"
          style={{
            position: "fixed",
            top: "0",
            left: "0",
            zIndex: "-1",
          }}
        />
        <VStack key={game.pregunta.preguntaId} spacing={10}>
          <Text style={titleStyle}>{game.pregunta.enunciado}</Text>
          {/* <Box as="figure" style={imageStyle}></Box> */}
          <Wrap spacing="30px" justify="center">
            {game.pregunta.contenido.map((imgUrl, index) => (
              <WrapItem key={index} boxShadow="none">
                <Image 
                  src={imgUrl}
                  key={index}
                  alt={`Emoción ${index}`}
                  boxSize={{ base: "150px", md: "200px" }} // Cambia el tamaño según el breakpoint de la pantalla
                  style={{ ...imageStyle, maxWidth: "100%" }} // Añade maxWidth para hacer las imágenes responsivas
                  backgroundSize="cover"
                  backgroundPosition="center"
                />
              </WrapItem>
            ))}
          </Wrap>
          <Wrap spacing="20px" justify="center">
            {game.respuestas.map((respuesta, index) => (
              <WrapItem key={index} boxShadow="none">
                <Box
                  key={index}
                  as="button"
                  onClick={() => handleAnswer(respuesta, index, game)}
                  sx={buttonStyle} // Cambiar a style si es necesario
                >
                  {respuesta.enunciado}
                </Box>
              </WrapItem>
            ))}
          </Wrap>
        </VStack>
      </>
    );
  };

  const renderGameType2 = (game) => {
    const titleStyle = {
      color: "#303030",
      textAlign: "center",
      fontFamily: "Poppins",
      fontSize: "40px",
      fontWeight: "600",
      lineHeight: "38px",
      letterSpacing: "-0.01px",
    };

    const imageStyle = {
      borderRadius: "50px",
      boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
      width: "433px",
      height: "346px",
      flexShrink: "0",
    };

    // Estilos actualizados para los botones
    const buttonStyle = {
      borderRadius: "20px",
      backgroundColor: "var(--TEA-Dark-Teal, #739691)",
      display: "flex",
      p: "21px 58px",
      justifyContent: "center",
      alignItems: "center",
      color: "white",
      fontSize: "18px",
      fontFamily: "Poppins",
      fontWeight: "500",
      _hover: {
        backgroundColor: "#5b7a74", // Considera definir un color más oscuro para el hover
      },
      cursor: "pointer", // Añade un cursor pointer para indicar que es un botón
    };

    return (
      <>
        <img
          src={FGame2Img}
          alt="Primera imagen"
          style={{
            position: "fixed",
            bottom: "0",
            right: "0",
            zIndex: "-1",
          }}
        />
        <img
          src={SGame2Img}
          alt="Segunda imagen"
          style={{
            position: "fixed",
            top: "0",
            left: "0",
            zIndex: "-1",
          }}
        />

        <VStack key={game.pregunta.preguntaId} spacing={8}>
          <Text style={titleStyle}>{game.pregunta.enunciado}</Text>
          <Wrap spacing="30px" justify="center">
            {game.pregunta.contenido.map((imgUrl, index) => (
              <WrapItem key={index} boxShadow="none">
                <Image
                  src={imgUrl}
                  key={index}
                  alt={`Emoción ${index}`}
                  boxSize={{ base: "150px", md: "200px" }} // Cambia el tamaño según el breakpoint de la pantalla
                  style={{ ...imageStyle, maxWidth: "100%" }} // Añade maxWidth para hacer las imágenes responsivas
                  backgroundSize="cover"
                  backgroundPosition="center"
                />
              </WrapItem>
            ))}
          </Wrap>

          {/* Añade spacing entre los botones usando HStack */}
          <HStack spacing="20px">
            {" "}
            {/* Ajusta el valor de 'spacing' según necesites */}
            {game.respuestas.map((respuesta, index) => (
              <Box
                key={index}
                as="button"
                onClick={() => handleAnswer(respuesta, index, game)}
                sx={buttonStyle} // Usa sx para estilos de Chakra UI
              >
                {respuesta.enunciado}
              </Box>
            ))}
          </HStack>
        </VStack>
      </>
    );
  };
  const renderGameType3 = (game) => {
    const titleStyles = {
      color: "#303030",
      fontFamily: "Poppins",
      fontSize: "40px",
      fontWeight: "600",
      lineHeight: "38px",
      letterSpacing: "-0.01em",
      textAlign: "center",
    };

    const imageStyles = {
      width: "430px",
      height: "350px",
      borderRadius: "50px",
      boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
      cursor: "pointer",
      transition: "transform 0.3s ease",
    };

    const hoverStyles = {
      transform: "scale(1.05)",
      boxShadow: "0 8px 15px rgba(0, 0, 0, 0.3)",
    };

    return (
      <VStack
        key={game.pregunta.preguntaId}
        spacing={8}
        backgroundColor="transparent"
        boxShadow="none"
        p={8}
      >
        <Text {...titleStyles}>{game.pregunta.enunciado}</Text>
        <Wrap spacing="30px" justify="center">
          {game.respuestas.map((respuesta, index) => (
            <WrapItem key={respuesta.respuestaId} boxShadow="none">
              <Image
                onClick={() => handleAnswer(respuesta, index, game)}
                sx={{ ...imageStyles, ...hoverStyles }}
                src={respuesta.contenido}
                alt={`Respuesta ${index}`}
              />
            </WrapItem>
          ))}
        </Wrap>
      </VStack>
    );
  };

  const renderGame = (game) => {
    switch (game.pregunta.tipoPreguntaId) {
      case 1:
        return renderGameType1(game);
      case 2:
        return renderGameType2(game);
      case 3:
        return renderGameType3(game); // Asegúrate de que esta función esté definida con la lógica apropiada
      default:
        return <Text>Level type not found.</Text>;
    }
  };
  return (
    <Center minHeight="100vh" flexDirection="column" p={5}>
      {games.length > 0 && currentGameIndex < games.length ? (
        <Box width="100vw" maxWidth="100%">
          {renderGame(games[currentGameIndex])}
        </Box>
      ) : (
        <Spinner />
      )}
      {modalIsOpen === true ? (
        
        <Modal isOpen={modalIsOpen} onClose={() => setModalIsOpen(false)}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Level Completed</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Box>
                <Text fontWeight="bold">Completion Date:</Text>
                <Text>
                  {new Date(
                    serverResponse.fechaCompletado
                  ).toLocaleString()}
                </Text>
              </Box>
              <Box>
                <Text fontWeight="bold">Score:</Text>
                <Text>{serverResponse.puntaje}</Text>
              </Box>
              <Box>
                <Text fontWeight="bold">Correct Answers:</Text>
                <Text>{serverResponse.respuestasCorrectas}</Text>
              </Box>
              <Box>
                <Text fontWeight="bold">Incorrect Answers:</Text>
                <Text>{serverResponse.respuestasIncorrectas}</Text>
              </Box>
              <Box>
                <Text fontWeight="bold">Completion Duration:</Text>
                <Text>{serverResponse.duracionCompletado}</Text>
              </Box>
              <Box>
                <Text fontWeight="bold">Average Response Time:</Text>
                <Text>{serverResponse.promedioTiempoRespuesta}</Text>
              </Box>
            </ModalBody>
            <ModalFooter>
              <Button onClick={() => navigate("/Home")}>Go to Levels</Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      ) : (
        <div></div>
      )}
    </Center>
  );
};

// Asegúrate de definir los estilos como se muestra en el ejemplo anterior
// ...

export default Game;